"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = void 0;

var _dateFormatting = _interopRequireDefault(require("@insided/shared/utils/dateFormatting"));

var cssAnchorName = 'local-datetime';
exports.cssAnchorName = cssAnchorName;

var LocalDatetime = function LocalDatetime(props) {
  var timestamp = props.timestamp,
      _props$showTime = props.showTime,
      showTime = _props$showTime === void 0 ? true : _props$showTime;

  if (!parseInt(timestamp)) {
    return '';
  }

  return (0, _dateFormatting.default)(timestamp, showTime);
};

var _default = LocalDatetime;
exports.default = _default;